const StringToDate = (datum) => {
    const b = datum.split('.');
    // console.log(b.length)
    const date = b.length > 1 ? new Date(b[2], b[1]-1, b[0]) : '';
    // console.log(`Datum als Date: ${datum}, ${date}`)
    return date;
}

export default StringToDate;